import { ReactNode } from 'react';

import { Dialog } from '@gasbi/shared/web/components/Dialog';

import { useRegisterFormRootContainer } from '@/hooks';

interface FormDialogProps {
  children: ReactNode;
  isModalOpen?: boolean;
  onDialogClose?: () => void;
  width?: string;
  height?: string;
  disableScroll?: boolean;
  hideBackdrop?: boolean;
}

const FormDialog = ({
  children,
  onDialogClose,
  isModalOpen = true,
  width,
  height,
  disableScroll = false,
  hideBackdrop = false,
}: FormDialogProps) => {
  const { ref: formRootContainerRef } = useRegisterFormRootContainer();
  return (
    <Dialog
      onClose={onDialogClose}
      open={isModalOpen}
      hideBackdrop={hideBackdrop}
      sx={{
        '.MuiPaper-root': {
          maxWidth: width || '896px',
          width: '100%',
          height,
          borderRadius: '8px',
          overflowY: disableScroll ? 'initial' : 'auto',
        },
      }}
      noContent
      ref={formRootContainerRef}
    >
      {children}
    </Dialog>
  );
};

export default FormDialog;
